import { cva } from 'cva';
export const tooltipVariant = cva({
    base: [
        '@z-50',
        // '@overflow-hidden',
        '@rounded',
        '@shadow-down6',
        '@bg-grey-1',
        '@text-grey-6',
    ],
    variants: {
        line: {
            single: ['@px-1', '@text-caption'],
            multiple: ['@px-2', '@py-1', '@text-b2']
        },
        animation: {
            true: [
                '@animate-in',
                '@fade-in-0',
                '@zoom-in-95',
                'data-[state=closed]:@animate-out',
                'data-[state=closed]:@fade-out-0',
                'data-[state=closed]:@zoom-out-95',
                'data-[side=bottom]:@slide-in-from-top-2',
                'data-[side=left]:@slide-in-from-right-2',
                'data-[side=right]:@slide-in-from-left-2',
                'data-[side=top]:@slide-in-from-bottom-2'
            ]
        }
    },
    defaultVariants: { line: 'multiple', animation: true }
});
export const tooltipContentVariantsMap = {
    line: ['single', 'multiple'],
    side: ['top', 'right', 'bottom', 'left'],
    animation: [true, false],
    align: ['start', 'center', 'end'],
    alignOffset: [null, 10, 20],
};
export const tooltipArrowVariantsMap = { useArrow: [true, false] };
export const bannedTooltipContentVariants = [
    { align: 'center', alignOffset: 10 },
    { align: 'center', alignOffset: 20 },
];
